import { EnhancedDialogService } from './EnhancedDialogService';
import { BaseAddressInterceptor } from '../interceptors/BaseAddressInterceptor';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { LookupService } from './LookupService';
import { ErrorHandler } from '@angular/core';
import { ObservableErrorHandler } from './ObservableErrorHandler';
import { AuthenticationExpiredInterceptor } from '../interceptors/AuthenticationExpiredInterceptor';
import { AppConfigurationService } from './AppConfigurationService';
import { RootNavigationManager } from './RootNavigationManager';
import { ClientActionSignalRHubService } from './ClientActionSignalRHubService';
import { DateTimeInterceptor } from '../interceptors/DateTimeInterceptor';
import { DownloadFileService } from '../../common/utilities/DownloadFileService';

export const Services: Array<any> = [
  EnhancedDialogService,
  BaseAddressInterceptor,
  LookupService,
  AppConfigurationService,
  ClientActionSignalRHubService,
  RootNavigationManager,
  DownloadFileService,
  {
    provide: HTTP_INTERCEPTORS,
    useClass: BaseAddressInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: AuthenticationExpiredInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: DateTimeInterceptor,
    multi: true,
  },
  {
    provide: ErrorHandler,
    useClass: ObservableErrorHandler,
  },
];

export * from './EnhancedDialogService';
export * from './LookupService';
export * from '../../datawarehouse/service/DataWarehouseService';



// WEBPACK FOOTER //
// ./src/app/core/services/index.ts